import { postRequest } from '../../../shared/utils';

export async function checkPSPTableRecordService({ mpNrWhere, screenGridId }) {
  const body = {
    columns: [
      'capex_id',
      'poe',
      'anzustrebender_liefertermin',
      'psp_c_a_element_cmm',
      'psp_c_a_element_ncp',
      'psp_c_a_element_femi',
      'budget_cmm',
      'budget_ncp',
      'budget_femi',
    ],
    screenGridId,
    schema: 'npi',
    table: 'psptable',
    filterModel: mpNrWhere,
    orderCol: 'id',
    order: 'asc',
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }

  return data;
}
